<template>
  <b-modal
    :hide-footer="true"
    title="Exclusão de solicitação de vaga para Serviço de Acolhimento"
    centered
    size="md"
    id="exclusao-solicitacao-vaga"
    :visible="false"
    :no-close-on-backdrop="true"
    :tabindex="0"
  >
    <div>
      <div class="row">
        <div class="col-lg-12">
          <form-input
            label="Unidade Solicitante"
            v-model="exclusao.unidade_solicitante"
            :required="true"
            :readonly="true"
          />
        </div>

        <div class="col-lg-12">
          <form-input
            label="Nome do Usuário"
            v-model="exclusao.nome_usuario"
            :required="true"
            :readonly="true"
          />
        </div>

        <div class="col-lg-12">
          <form-textarea
            label="Motivo da Exclusão"
            v-model="exclusao.motivo"
            :required="true"
            placeholder="Descreva o motivo da exclusão da solicitação..."
          />
        </div>

        <div class="col-lg-12">
          <form-input
            label="Data da Ação"
            type="date"
            v-model="exclusao.data_acao"
            :required="true"
          />
        </div>
      </div>

      <div class="row pt-2 px-2 d-flex justify-content-end">
        <button @click="confirmarExclusao" class="btn btn-danger btn-submit">
          <i class="fas fa-trash-alt" />
          Confirmar Exclusão
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      exclusao: {
        unidade_solicitante: this.item?.unidade_solicitante || '',
        nome_usuario: this.item?.nome_usuario || '',
        motivo: '',
        data_acao: new Date().toISOString().substr(0, 10)
      }
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.exclusao.unidade_solicitante = val?.unidade_solicitante || '';
        this.exclusao.nome_usuario = val?.nome_usuario || '';
      }
    }
  },
  methods: {
    confirmarExclusao() {
      if (!this.exclusao.motivo || !this.exclusao.data_acao) {
        this.$bvToast.toast("Preencha todos os campos obrigatórios.", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      let payload = {
        ...this.exclusao,
        id: this.item.id
      };

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post(`api/dashboard/acolhimento/solicitacao/excluir`, payload)
        .then((response) => {
          ladda.stop();
          this.$bvModal.hide("exclusao-solicitacao-vaga");

          this.$bvToast.toast(response.data.message || 'Solicitação excluída com sucesso!', {
            title: "Sucesso",
            variant: "success",
            solid: true,
          });

          setTimeout(() => window.location.reload(), 800);
        })
        .catch((error) => {
          ladda.stop();
          this.$bvToast.toast(
            error.response?.data?.message || 'Erro ao excluir solicitação.',
            {
              title: "Erro",
              variant: "danger",
              solid: true,
            }
          );
        });
    }
  }
};
</script>
